import { gql } from '../../../../../hooks'

export const DELETE_POINTS = gql`
  mutation AdministrationDeleteSamplingPoints($id: ID!) {
    aDelete(path: "sampling/points", id: $id) {
    }
  }
`

export const LIST_POINTS = gql`
  query AdministrationListSamplingPoints(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "sampling/points"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
